import {createContext} from 'react'

const Cnt = createContext(null)

export {
	Cnt
}
